<ng-scrollbar
	class="absolute w-full h-full top-0 left-0 max-w-full"
	track="vertical"
	viewClass="child:max-w-full"
	visibility="hover"
>
	<ng-container
		*ngFor="let section of sections$ | async; trackBy: trackBySection"
	>
		<ng-container *ngIf="section.modules$ | async; let modules">
			<spr-phase-section
				*ngIf="modules.length > 0"
				[modules]="modules"
				[section]="section.instance"
			></spr-phase-section>
		</ng-container>
	</ng-container>
</ng-scrollbar>
